import { useState } from 'react';
import './App.css';
import LoginPage from './components/LoginPage';
import LandingPage from './components/LandingPage';

function App() {
  const [session, setSession] = useState(() => {
    const token = localStorage.getItem('sadaqa25_token');
    const userRaw = localStorage.getItem('sadaqa25_user');

    if (!token || !userRaw) {
      return null;
    }

    try {
      return { token, user: JSON.parse(userRaw) };
    } catch (error) {
      localStorage.removeItem('sadaqa25_token');
      localStorage.removeItem('sadaqa25_user');
      return null;
    }
  });

  const handleLoginSuccess = (data) => {
    setSession(data);
    localStorage.setItem('sadaqa25_token', data.token);
    localStorage.setItem('sadaqa25_user', JSON.stringify(data.user));
  };

  const handleLogout = () => {
    setSession(null);
    localStorage.removeItem('sadaqa25_token');
    localStorage.removeItem('sadaqa25_user');
  };

  if (!session) {
    return <LoginPage onSuccess={handleLoginSuccess} />;
  }

  return <LandingPage session={session} onLogout={handleLogout} />;
}

export default App;
